import { render, staticRenderFns } from "./guiji.vue?vue&type=template&id=60299b66&scoped=true&"
import script from "./guiji.vue?vue&type=script&lang=js&"
export * from "./guiji.vue?vue&type=script&lang=js&"
import style0 from "./guiji.vue?vue&type=style&index=0&id=60299b66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60299b66",
  null
  
)

export default component.exports